import { useEffect } from 'react';
import { PrinterSettingContent } from './PrinterSettingContent';

interface PrinterSettingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PrinterSettingModal = ({ isOpen, onClose }: PrinterSettingModalProps) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      return () => document.removeEventListener('keydown', handleEsc);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex justify-center items-center">
      {/* 배경 클릭 시 닫기 */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden
      />
      <div
        className="relative flex flex-col bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-hidden mx-4"
        onClick={e => e.stopPropagation()}
      >
        {/* 헤더: 닫기 버튼만 (제목은 Container 내부에 있음) */}
        <div className="flex items-center justify-end flex-shrink-0 px-2 py-1 border-b bg-gray-50">
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded hover:bg-gray-200 text-gray-600"
            title="닫기"
          >
            ✕
          </button>
        </div>
        {/* 본문: 스크롤 가능 */}
        <div className="overflow-auto flex-1 min-h-0">
          <PrinterSettingContent onClose={onClose} />
        </div>
      </div>
    </div>
  );
};

